<template>

  <head>

    <meta charset="utf-8" />
    <title>County Revenue System | Collector Performance Rankings</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Team" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-light p-4 rounded-3 shadow-sm">
                <div>
                  <h4 class="mb-2 font-size-20">
                    <i class="bx bx-trophy text-warning me-2"></i>
                    Collector Performance Rankings
                  </h4>
                  <p class="text-muted mb-0">Track and compare collector performance across different metrics</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0 bg-transparent">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')" class="text-decoration-none">Dashboard</a></li>
                    <li class="breadcrumb-item active">Rankings</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Filter Section -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-gradient-primary text-white border-0">
                  <h5 class="mb-0 text-white">
                    <i class="bx bx-filter-alt me-2"></i>Filters & Options
                  </h5>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <!-- Rank Type - Primary Filter -->
                    <div class="col-md-4 col-lg-3">
                      <div class="form-group">
                        <label class="form-label fw-semibold d-flex align-items-center">
                          <i class="bx bx-list-check text-primary me-2"></i>
                          Rank By
                        </label>
                        <select v-model="rankType" class="form-select form-select-lg border-2" style="border-color: #e9ecef;">
                          <option value="overall" selected>📊 Overall Performance</option>
                          <option value="subcounty">🗺️ Sub County</option>
                          <option value="ward">📍 Ward</option>
                          <option value="zone">🧭 Zone</option>
                          <option value="stream">💰 Revenue Stream</option>
                          <option value="transaction">📝 Transaction Count</option>
                        </select>
                        <small class="text-muted d-block mt-1">Select how you want to rank collectors</small>
                      </div>
                    </div>

                    <!-- Date Range -->
                    <div class="col-md-4 col-lg-3">
                      <div class="form-group">
                        <label class="form-label fw-semibold d-flex align-items-center">
                          <i class="bx bx-calendar text-primary me-2"></i>
                          Date Range
                        </label>
                        <div class="input-group">
                          <input v-model="dateFrom" type="date" class="form-control border-2" style="border-color: #e9ecef;">
                          <span class="input-group-text bg-light border-2" style="border-color: #e9ecef;">to</span>
                          <input v-model="dateTo" type="date" class="form-control border-2" style="border-color: #e9ecef;">
                        </div>
                        <small class="text-muted d-block mt-1">From {{ formatDateDisplay(dateFrom) }} to {{ formatDateDisplay(dateTo) }}</small>
                      </div>
                    </div>

                    <!-- Sub County Filter -->
                    <div class="col-md-4 col-lg-3">
                      <div class="form-group">
                        <label class="form-label fw-semibold d-flex align-items-center">
                          <i class="bx bx-map text-primary me-2"></i>
                          Sub County Filter
                        </label>
                        <select v-model="selectedSubCounty" class="form-select form-select-lg border-2" style="border-color: #e9ecef;">
                          <option value="">All Sub Counties</option>
                          <option v-for="sc in subCounties" :key="sc.subCountyID" :value="sc.subCountyID">
                            {{ sc.subCountyName }}
                          </option>
                        </select>
                        <small class="text-muted d-block mt-1">{{ selectedSubCounty ? 'Filtered view' : 'Showing all sub counties' }}</small>
                      </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="col-12 col-lg-3 d-flex align-items-end gap-2">
                      <button
                          @click="exportData"
                          class="btn btn-success btn-lg flex-fill"
                          :disabled="loading || (currentData.length === 0 && groupedData.length === 0)"
                          title="Export data as CSV file"
                      >
                        <i class="bx bxs-download me-2"></i>
                        <span class="d-none d-sm-inline">Export</span>
                      </button>
                      <button
                          @click="refreshData"
                          class="btn btn-outline-primary btn-lg"
                          :disabled="loading"
                          title="Manually refresh data"
                      >
                        <i v-if="loading" class="bx bx-loader-alt bx-spin"></i>
                        <i v-else class="bx bx-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Stats Cards -->
          <div class="row mb-4" v-if="!loading && getTotalRecords() > 0">
            <div class="col-md-6 col-lg-3">
              <div class="card border-0 shadow-sm bg-gradient-info text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <p class="mb-1 opacity-75">Total Records</p>
                      <h4 class="mb-0 fw-bold text-white">{{ getTotalRecords() }}</h4>
                    </div>
                    <i class="bx bx-bar-chart-alt-2 text-white opacity-50" style="font-size: 2.5rem;"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="card border-0 shadow-sm bg-gradient-success text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <p class="mb-1 opacity-75 text-white">Total Collected</p>
                      <h4 class="mb-0 fw-bold text-white">{{ formatPrice(getTotalCollected()) }}</h4>
                    </div>
                    <i class="bx bx-money text-white opacity-50" style="font-size: 2.5rem;"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="card border-0 shadow-sm bg-gradient-warning text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <p class="mb-1 opacity-75 text-white">Avg per Collector</p>
                      <h4 class="mb-0 fw-bold text-white">{{ formatPrice(getAveragePerCollector()) }}</h4>
                    </div>
                    <i class="bx bx-user-check text-white opacity-50" style="font-size: 2.5rem;"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="card border-0 shadow-sm bg-gradient-danger text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <p class="mb-1 opacity-75 text-white">Total Transactions</p>
                      <h4 class="mb-0 fw-bold text-white">{{ getTotalTransactions() }}</h4>
                    </div>
                    <i class="bx bx-receipt text-white opacity-50" style="font-size: 2.5rem;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Results Section -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 class="mb-0">
                        <i class="bx bx-list-ul me-2"></i>
                        {{ getRankingTitle() }}
                      </h5>
                    </div>
                    <div v-if="!loading" class="d-flex gap-2 align-items-center">
                      <span class="badge bg-light text-dark" v-if="getTotalRecords() > 0">
                        <i class="bx bx-check-circle me-1"></i>
                        {{ getTotalRecords() }} Collectors
                      </span>
                      <span v-else class="badge bg-warning">
                        <i class="bx bx-info-circle me-1"></i>
                        No data
                      </span>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted fw-semibold">Loading rankings data...</p>
                    <small class="text-muted">Please wait while we fetch the latest data</small>
                  </div>

                  <!-- Overall Performance View -->
                  <div v-else-if="rankType === 'overall'">
                    <RankingsTable
                        :data="currentData"
                        :loading="loading"
                        :columns="['rank', 'collector', 'subcounty', 'totalAmount', 'transactions', 'avgTransaction']"
                    />
                  </div>

                  <!-- By Sub County View -->
                  <div v-else-if="rankType === 'subcounty'">
                    <div v-if="groupedData.length > 0" class="accordion" id="subCountyAccordion">
                      <div
                          v-for="(group, index) in groupedData"
                          :key="'sc-' + index"
                          class="accordion-item"
                      >
                        <h2 class="accordion-header">
                          <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="'#collapse-sc-' + index"
                          >
                            <div class="d-flex align-items-center flex-grow-1">
                              <i class="bx bx-map me-2 text-primary"></i>
                              <strong class="me-3">{{ group.groupName }}</strong>
                              <span class="badge bg-info ms-2">{{ group.collectors.length }} Collectors</span>
                              <span class="badge bg-success ms-2">{{ formatPrice(group.totalAmount) }}</span>
                            </div>
                          </button>
                        </h2>
                        <div :id="'collapse-sc-' + index" class="accordion-collapse collapse" :class="{ show: index === 0 }">
                          <div class="accordion-body p-0">
                            <RankingsTable
                                :data="group.collectors"
                                :columns="['rank', 'collector', 'totalAmount', 'transactions', 'avgTransaction']"
                                :show-title="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="alert alert-info text-center py-5 mb-0">
                      <i class="bx bx-info-circle me-2" style="font-size: 2rem;"></i>
                      <p class="mb-0">No data available for the selected criteria</p>
                    </div>
                  </div>

                  <!-- By Ward View -->
                  <div v-else-if="rankType === 'ward'">
                    <div v-if="groupedData.length > 0" class="accordion" id="wardAccordion">
                      <div
                          v-for="(group, index) in groupedData"
                          :key="'ward-' + index"
                          class="accordion-item"
                      >
                        <h2 class="accordion-header">
                          <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="'#collapse-ward-' + index"
                          >
                            <div class="d-flex align-items-center flex-grow-1">
                              <i class="bx bx-map-alt me-2 text-primary"></i>
                              <strong class="me-3">{{ group.groupName }}</strong>
                              <span class="badge bg-info ms-2">{{ group.collectors.length }} Collectors</span>
                              <span class="badge bg-success ms-2">{{ formatPrice(group.totalAmount) }}</span>
                            </div>
                          </button>
                        </h2>
                        <div :id="'collapse-ward-' + index" class="accordion-collapse collapse" :class="{ show: index === 0 }">
                          <div class="accordion-body p-0">
                            <RankingsTable
                                :data="group.collectors"
                                :columns="['rank', 'collector', 'totalAmount', 'transactions', 'avgTransaction']"
                                :show-title="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="alert alert-info text-center py-5 mb-0">
                      <i class="bx bx-info-circle me-2" style="font-size: 2rem;"></i>
                      <p class="mb-0">No data available for the selected criteria</p>
                    </div>
                  </div>

                  <!-- By Zone View -->
                  <div v-else-if="rankType === 'zone'">
                    <div v-if="groupedData.length > 0" class="accordion" id="zoneAccordion">
                      <div
                          v-for="(group, index) in groupedData"
                          :key="'zone-' + index"
                          class="accordion-item"
                      >
                        <h2 class="accordion-header">
                          <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="'#collapse-zone-' + index"
                          >
                            <div class="d-flex align-items-center flex-grow-1">
                              <i class="bx bx-map-pin me-2 text-primary"></i>
                              <strong class="me-3">{{ group.groupName }}</strong>
                              <span class="badge bg-info ms-2">{{ group.collectors.length }} Collectors</span>
                              <span class="badge bg-success ms-2">{{ formatPrice(group.totalAmount) }}</span>
                            </div>
                          </button>
                        </h2>
                        <div :id="'collapse-zone-' + index" class="accordion-collapse collapse" :class="{ show: index === 0 }">
                          <div class="accordion-body p-0">
                            <RankingsTable
                                :data="group.collectors"
                                :columns="['rank', 'collector', 'totalAmount', 'transactions', 'avgTransaction']"
                                :show-title="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="alert alert-info text-center py-5 mb-0">
                      <i class="bx bx-info-circle me-2" style="font-size: 2rem;"></i>
                      <p class="mb-0">No data available for the selected criteria</p>
                    </div>
                  </div>

                  <!-- By Revenue Stream View -->
                  <div v-else-if="rankType === 'stream'">
                    <div v-if="groupedData.length > 0" class="accordion" id="streamAccordion">
                      <div
                          v-for="(group, index) in groupedData"
                          :key="'stream-' + index"
                          class="accordion-item"
                      >
                        <h2 class="accordion-header">
                          <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="'#collapse-stream-' + index"
                          >
                            <div class="d-flex align-items-center flex-grow-1">
                              <i class="bx bx-flow-horizontal me-2 text-primary"></i>
                              <strong class="me-3">{{ group.groupName }}</strong>
                              <span class="badge bg-info ms-2">{{ group.collectors.length }} Collectors</span>
                              <span class="badge bg-success ms-2">{{ formatPrice(group.totalAmount) }}</span>
                            </div>
                          </button>
                        </h2>
                        <div :id="'collapse-stream-' + index" class="accordion-collapse collapse" :class="{ show: index === 0 }">
                          <div class="accordion-body p-0">
                            <RankingsTable
                                :data="group.collectors"
                                :columns="['rank', 'collector', 'totalAmount', 'transactions', 'avgTransaction']"
                                :show-title="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="alert alert-info text-center py-5 mb-0">
                      <i class="bx bx-info-circle me-2" style="font-size: 2rem;"></i>
                      <p class="mb-0">No data available for the selected criteria</p>
                    </div>
                  </div>

                  <!-- By Transaction Count View -->
                  <div v-else-if="rankType === 'transaction'">
                    <RankingsTable
                        :data="currentData"
                        :loading="loading"
                        :columns="['rank', 'collector', 'transactions', 'totalAmount', 'avgTransaction']"
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © {{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Powered by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import {biller, execute, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import RankingsTable from "@/components/rankings/RankingsTable.vue";
import moment from "moment";

export default {
  name: "CollectorPerformanceRankings",
  components: {
    NavigationBar,
    RankingsTable
  },
  data() {
    return {
      loading: false,

      // Date filters
      dateFrom: moment().startOf('month').format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      selectedSubCounty: '',

      // Ranking type selector
      rankType: 'overall',

      // Sub counties
      subCounties: [],

      // Current data
      currentData: [],
      groupedData: []
    };
  },
  mounted() {
    this.loadSubCounties();
    this.menuAccess();
    // Auto-load overall rankings for current month
    this.$nextTick(() => {
      this.loadRankingData();
    });
  },
  watch: {
    rankType(newVal, oldVal) {
      // Auto-load when rank type changes (skip initial load)
      if (oldVal !== undefined) {
        this.loadRankingData();
      }
    },
    dateFrom() {
      // Auto-load when date from changes
      if (this.currentData.length > 0 || this.groupedData.length > 0) {
        this.loadRankingData();
      }
    },
    dateTo() {
      // Auto-load when date to changes
      if (this.currentData.length > 0 || this.groupedData.length > 0) {
        this.loadRankingData();
      }
    },
    selectedSubCounty() {
      // Auto-load when sub county changes
      if (this.currentData.length > 0 || this.groupedData.length > 0) {
        this.loadRankingData();
      }
    }
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    formatDateDisplay(dateStr) {
      return moment(dateStr).format('DD MMM YYYY');
    },

    numberFormat(num) {
      if (!num) return '0';
      return new Intl.NumberFormat("en-GB").format(num);
    },

    getRankingTitle() {
      const titles = {
        overall: 'Overall Collector Performance',
        subcounty: 'Collector Rankings by Sub County',
        ward: 'Collector Rankings by Ward',
        zone: 'Collector Rankings by Zone',
        stream: 'Collector Rankings by Revenue Stream',
        transaction: 'Collectors Ranked by Transaction Count'
      };
      return titles[this.rankType] || 'Collector Rankings';
    },

    getTotalRecords() {
      if (this.rankType === 'overall' || this.rankType === 'transaction') {
        return this.currentData.length;
      }
      return this.groupedData.reduce((sum, group) => sum + group.collectors.length, 0);
    },

    getTotalCollected() {
      if (this.rankType === 'overall' || this.rankType === 'transaction') {
        return this.currentData.reduce((sum, item) => sum + parseFloat(item.totalCollected || 0), 0);
      }
      return this.groupedData.reduce((sum, group) =>
          sum + group.collectors.reduce((s, item) => s + parseFloat(item.totalCollected || 0), 0), 0);
    },

    getTotalTransactions() {
      if (this.rankType === 'overall' || this.rankType === 'transaction') {
        return this.currentData.reduce((sum, item) => sum + (item.transactionCount || 0), 0);
      }
      return this.groupedData.reduce((sum, group) =>
          sum + group.collectors.reduce((s, item) => s + (item.transactionCount || 0), 0), 0);
    },

    getAveragePerCollector() {
      const total = this.getTotalCollected();
      const count = this.getTotalRecords();
      return count > 0 ? total / count : 0;
    },

    gotTo(route) {
      this.$router.push(route);
    },

    async loadSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties || [];
        }
      } catch (e) {
        console.error('Error loading sub-counties:', e);
      }
    },

    async loadRankingData() {
      this.loading = true;
      this.currentData = [];
      this.groupedData = [];

      try {
        const data = new FormData();
        data.append("function", "getCollectorRankingsByType");
        data.append("rankType", this.rankType);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        if (this.selectedSubCounty) {
          data.append("subCountyID", this.selectedSubCounty);
        }

        const res = await execute(data, biller);

        if (res.data.success) {
          const rankingsData = res.data.data;

          // Check if grouped or flat data
          if (rankingsData.grouped) {
            this.groupedData = rankingsData.results || [];
          } else {
            this.currentData = rankingsData.results || [];
          }
        } else {
          console.error('Error:', res.data.message);
        }
      } catch (e) {
        console.error('Error loading rankings:', e);
      } finally {
        this.loading = false;
      }
    },

    refreshData() {
      this.loadRankingData();
    },

    exportData() {
      if (this.currentData.length === 0 && this.groupedData.length === 0) {
        alert('No data to export. Please load rankings first.');
        return;
      }

      try {
        let csvContent = '';
        let fileName = `Collector_Rankings_${this.rankType}_${this.dateFrom}_to_${this.dateTo}.csv`;

        if (this.rankType === 'overall' || this.rankType === 'transaction') {
          csvContent = this.generateFlatCSV(this.currentData);
        } else {
          csvContent = this.generateGroupedCSV(this.groupedData);
        }

        const metadata = [
          `Collector Performance Rankings Report`,
          `Rank Type,${this.rankType}`,
          `Period,"${this.dateFrom} to ${this.dateTo}"`,
          `Generated,"${moment().format('DD/MM/YYYY HH:mm:ss')}"`,
          ``,
          ``
        ];

        const finalCSV = metadata.join('\n') + '\n' + csvContent;

        const blob = new Blob(['\ufeff' + finalCSV], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert('Export successful! File downloaded.');
      } catch (error) {
        console.error('Export error:', error);
        alert('Error exporting data: ' + error.message);
      }
    },

    generateFlatCSV(data) {
      const headers = ['Rank', 'Collector Name', 'Collector ID', 'Phone', 'Total Amount', 'Transactions', 'Avg Transaction'];
      const rows = data.map((item, index) => [
        item.rank || (index + 1),
        this.escapeCSV(item.collectorName || item.invoicedBy || ''),
        this.escapeCSV(item.collectorID || item.invoicedByIdNo || ''),
        this.escapeCSV(item.collectorPhone || item.invoicedByPhoneNumber || ''),
        parseFloat(item.totalCollected || 0).toFixed(2),
        item.transactionCount || 0,
        parseFloat(item.averageTransaction || 0).toFixed(2)
      ]);

      return [headers, ...rows].map(row => row.join(',')).join('\n');
    },

    generateGroupedCSV(groupedData) {
      let csv = '';

      groupedData.forEach(group => {
        csv += this.escapeCSV(group.groupName) + ' - ' + group.collectors.length + ' Collectors\n';

        const headers = ['Rank', 'Collector Name', 'Collector ID', 'Phone', 'Total Amount', 'Transactions', 'Avg Transaction'];
        csv += headers.join(',') + '\n';

        group.collectors.forEach((item, index) => {
          csv += [
            item.rank || (index + 1),
            this.escapeCSV(item.collectorName || item.invoicedBy || ''),
            this.escapeCSV(item.collectorID || item.invoicedByIdNo || ''),
            this.escapeCSV(item.collectorPhone || item.invoicedByPhoneNumber || ''),
            parseFloat(item.totalCollected || 0).toFixed(2),
            item.transactionCount || 0,
            parseFloat(item.averageTransaction || 0).toFixed(2)
          ].join(',') + '\n';
        });

        csv += '\n';
      });

      return csv;
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Collector Performance Rankings");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
/* Gradient Backgrounds */
.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.bg-gradient-info {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
}

.bg-gradient-success {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
}

.bg-gradient-danger {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
}

/* Cards */
.card {
  border-radius: 0.75rem;
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1);
}

/* Form Controls */
.form-select, .form-control {
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.form-select:focus, .form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.form-label {
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

/* Badges */
.badge {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: 0.4rem;
}

/* Accordion */
.accordion-button {
  padding: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.accordion-button:not(.collapsed) {
  background-color: #f8f9fa;
  color: #667eea;
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23667eea'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

/* Buttons */
.btn {
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1.5rem rgba(102, 126, 234, 0.4);
}

.btn-success {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  border: none;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1.5rem rgba(46, 204, 113, 0.4);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Spinner Animation */
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Utility Classes */
.opacity-75 {
  opacity: 0.75;
}

.opacity-50 {
  opacity: 0.5;
}

/* Breadcrumb */
.breadcrumb {
  background-color: transparent;
}

.breadcrumb-item a {
  color: #667eea;
  transition: color 0.3s ease;
}

.breadcrumb-item a:hover {
  color: #764ba2;
}

/* Responsive */
@media (max-width: 768px) {
  .page-title-box {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .btn-lg {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .form-select-lg, .form-control {
    font-size: 0.95rem;
  }

  .card-body {
    padding: 1rem;
  }
}

/* Alert Styling */
.alert {
  border-radius: 0.75rem;
  border: none;
}

.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
}
</style>